updateWithProxyFn